// Captured source AccordionTab: independent rows; 400ms ease-out expansion and
// 250ms ease collapse. Lifecycle/cancel handling avoids stale height or overflow.
if (!customElements.get('accordion-tab')) {
 class AccordionTab extends HTMLElement {
  connectedCallback() {
   if (this.initialized) return;
   this.details = this.querySelector('details');
   this.summary = this.querySelector('summary');
   this.content = this.querySelector('.accordion__content');
   if (!this.details || !this.summary || !this.content) return;
   this.initialized = true;
   this.animation = null;
   this.isClosing = false;
   this.isExpanding = false;
   this.generation = 0;
   this.onSummaryClick = event => this.onClick(event);
   this.summary.addEventListener('click', this.onSummaryClick);
  }
  disconnectedCallback() {
   if (!this.initialized) return;
   this.summary.removeEventListener('click', this.onSummaryClick);
   this.generation++;
   this.cancelPendingAnimation();
   this.clearTransientStyles();
   this.initialized = false;
  }
  onClick(event) {
   event.preventDefault();
   this.transition(this.isClosing || !this.details.open);
  }
  cancelPendingAnimation() {
   if (this.frame) cancelAnimationFrame(this.frame);
   this.frame = null;
   if (this.animation) {
    this.animation.onfinish = null;
    this.animation.oncancel = null;
    this.animation.cancel();
   }
   this.animation = null;
  }
  clearTransientStyles() {
   this.details.style.height = '';
   this.details.style.overflow = '';
   this.isClosing = false;
   this.isExpanding = false;
  }
  transition(open) {
   const startHeight = this.details.getBoundingClientRect().height;
   const generation = ++this.generation;
   this.cancelPendingAnimation();
   this.isClosing = !open;
   this.isExpanding = open;
   this.details.style.height = `${startHeight}px`;
   this.details.style.overflow = 'hidden';
   if (open) this.details.open = true;
   const finish = () => {
    if (generation !== this.generation) return;
    this.details.open = open;
    this.animation = null;
    this.frame = null;
    this.clearTransientStyles();
   };
   if (matchMedia('(prefers-reduced-motion: reduce)').matches || !this.details.animate) {
    finish();
    return;
   }
   this.frame = requestAnimationFrame(() => {
    this.frame = null;
    if (generation !== this.generation || !this.isConnected) return;
    const summaryMargin = parseFloat(getComputedStyle(this.summary).marginTop) || 0;
    const endHeight = this.summary.offsetHeight + summaryMargin + (open ? this.content.offsetHeight : 0);
    this.animation = this.details.animate({height: [`${startHeight}px`, `${endHeight}px`]}, {duration: open ? 400 : 250, easing: open ? 'ease-out' : 'ease'});
    this.animation.onfinish = finish;
    this.animation.oncancel = finish;
   });
  }
 }
 customElements.define('accordion-tab', AccordionTab);
}
